import "./mentionsLegales.scss";

export default function MentionsLegales() {
  return (
    <div className="mentionsLegales">
      <div className="mentions-legales-container">
        <h2>Mentions légales</h2>
        <section>
          <h3>ENTREPRISE</h3>
          <p>
            <span>Nom Entreprise :</span> I.D Electricité & Serrurerie <br />
            <span>Forme :</span> Entreprise individuelle <br />
            <span>Représentée par :</span> François SESANNE <br />
            <span>Siège social :</span> 2 impasse Grand Cabaret 84310 Morières
            lès Avignon <br />
            <span>N° SIRET :</span> 40290340500031 <br />
            <span>N° TVA intracommunautaire :</span> FR17402903405 <br />
            <span>RCS :</span> Avignon <br />
            <span>Email :</span> i.d.electrique84@gmail.com <br />
          </p>
        </section>
        <section>
          <h3>SITE WEB</h3>
          <h4>Edition & Publication</h4>
          <p>
            Le site www.idelectriciteserrurerie.fr est édité par l'entreprise
            individuelle SESANNE MICHEL.
            <br />
            Le directeur de publication est François SESANNE, gérant de
            l'entreprise I.D Electricité & Serrurerie.
          </p>
          <h4>Hébergement</h4>
          <p>
            L'hébergeur du site www.idelectriciteserrurerie.fr est la société
            GitHub, Inc.
            <br />
            <span className="adresse">Adresse </span>: 88 Colin P. Kelly Jr.
            Street, San Francisco, CA 94107, USA
          </p>
          <h4>Responsabilité</h4>
          <p>
            La responsabilité de l’Editeur ne peut être engagée en cas de
            défaillance, panne ou interruption empêchant l’accès au Site ou
            limitant son usage.
            <br />
            Le matériel de connexion et de navigation utilisée relève de la
            seule responsabilité de son utilisateur, lequel doit prendre toutes
            les mesures appropriées pour protéger son matériel, s’agissant
            notamment d’attaques virales.
            <br />
            L’Editeur décline toute responsabilité résultant d’une intrusion
            frauduleuse d’un tiers ayant entrainé une modification des
            informations présentées sur le Site.
            <br />
          </p>
          <h4>Propriété intellectuelle</h4>
          <p>
            Le contenu du site www.idelectriciteserrurerie.fr est la propriété
            exclusive de l'Editeur ou de ses partenaires et est protégé par les
            lois françaises et internationales relatives à la propriété
            intellectuelle.
            <br />
            Photos fournies par Unsplash.
            <br />
            Toute reproduction, distribution, modification, adaptation,
            retransmission ou publication, même partielle, de ces différents
            éléments est strictement interdite sans l'accord exprès par écrit de
            l'Editeur.
          </p>
          <h4>RGPD et protection des données personnelles</h4>
          <p>
            Conformément au règlement européen en matière de protection des
            données personnelles, vous disposez des droits d’interrogation,
            d’accès, de modification, d’opposition et de rectification sur les
            données personnelles vous concernant.
            <br />
            Nous ne collectons ni ne partageons vos données personnelles.
          </p>
          <h4>Cookies</h4>
          <p>
            La navigation sur le Site est susceptible d’entrainer l'utilisation
            de cookies.
          </p>
        </section>
        <section>
          <h3>Autres dispositions légales</h3>
          <h4>Médiation de la Consommation</h4>
          <p>
            Conformément aux articles L.616-1 et R.616-1 du code de la
            consommation, nous proposons un dispositif de médiation de la
            consommation. L'entité de médiation retenue est : MEDIATION CONSOMMATION DÉVELOPPEMENT/MED CONSO DEV.
            <br /> En cas de litige, vous pouvez déposer votre réclamation sur
            son site : https://www.cnpm-mediation-consommation.eu/ ou par voie postale en écrivant à MEDIATION CONSOMMATION DÉVELOPPEMENT/MED CONSO DEV
            Centre d’Affaires Stéphanois SAS IMMEUBLE L’HORIZON – ESPLANADE DE FRANCE 3, RUE J. CONSTANT MILLERET – 42000 SAINT-ÉTIENNE
          </p>
          <h4>Assurance de Responsabilité Décennale</h4>
          <p>
            Assurance de responsabilité décennale obligatoire, souscrite auprès
            du Siège Social April Partenaires 15 rue Jules Ferry BP 60307 -
            35303 - Fougères, n°:23034644930.
          </p>
        </section>
      </div>
    </div>
  );
}
